<template>
  <div class="page-content xm-page-content"><slot></slot></div>
</template>

<script>
export default {
  name: 'xm-page-content'
};

</script>

<style lang='less' rel="stylesheet/less">
.xm-page-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 0;
  -ms-touch-action: pan-y;
}

</style>



// WEBPACK FOOTER //
// src/components/Content.vue